export default __webpack_public_path__ + "static/service_emergency@2x-feca9f4cfcad341bd7fa72dac3a3c416.jpg";